export const G_DIVISIONS = "/goaliedivisions";
export const G_AVAILABILITY = "/goalieavailability";
export const G_CONTACT = "/goaliecontact";
export const G_SCHEDULE = "/goalieschedule";
export const G_ASSIGNMENT = "/goalieassignmentseason";

export class GoalieAssignUrl {
  public static pattern = GoalieAssignUrl.createUrl(":gameId");

  static createUrl(gameId: number | string): string {
    return `/goalieassign/${gameId}`;
  }
}
